import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiAtSign({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.00002 5.99984C6.89545 5.99984 6.00002 6.89527 6.00002 7.99984C6.00002 9.10441 6.89545 9.99984 8.00002 9.99984C9.10459 9.99984 10 9.10441 10 7.99984C10 6.89527 9.10459 5.99984 8.00002 5.99984ZM4.66669 7.99984C4.66669 6.15889 6.15907 4.6665 8.00002 4.6665C9.84097 4.6665 11.3334 6.15889 11.3334 7.99984C11.3334 9.84079 9.84097 11.3332 8.00002 11.3332C6.15907 11.3332 4.66669 9.84079 4.66669 7.99984Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.86675 1.37007C6.36318 0.662901 8.05483 0.482742 9.66663 0.858889C11.2784 1.23504 12.7156 2.14537 13.7444 3.44186C14.7733 4.73835 15.3333 6.34476 15.3334 7.99987V8.66658C15.3334 9.37382 15.0524 10.0521 14.5523 10.5522C14.0522 11.0523 13.3739 11.3332 12.6667 11.3332C11.9595 11.3332 11.2812 11.0523 10.7811 10.5522C10.281 10.0521 10 9.37382 10 8.66658V5.33325C10 4.96506 10.2985 4.66658 10.6667 4.66658C11.0349 4.66658 11.3334 4.96506 11.3334 5.33325V8.66658C11.3334 9.0202 11.4738 9.35934 11.7239 9.60939C11.9739 9.85944 12.3131 9.99991 12.6667 9.99991C13.0203 9.99991 13.3595 9.85944 13.6095 9.60939C13.8596 9.35934 14 9.0202 14 8.66658V7.99995C14 7.99994 14 7.99997 14 7.99995C13.9999 6.64579 13.5418 5.33143 12.7 4.27067C11.8582 3.20991 10.6824 2.46509 9.36361 2.15733C8.04486 1.84958 6.66079 1.99698 5.43644 2.57557C4.21208 3.15417 3.21947 4.12993 2.61998 5.34419C2.0205 6.55845 1.84941 7.9398 2.13453 9.26362C2.41965 10.5874 3.14421 11.7759 4.19041 12.6357C5.2366 13.4955 6.54289 13.9762 7.89687 13.9994C9.25085 14.0227 10.5729 13.5873 11.648 12.764C11.9403 12.5401 12.3588 12.5956 12.5827 12.8879C12.8065 13.1802 12.751 13.5987 12.4587 13.8225C11.1446 14.8288 9.52881 15.361 7.87395 15.3326C6.21908 15.3041 4.6225 14.7167 3.34382 13.6658C2.06514 12.6149 1.17956 11.1624 0.831084 9.54435C0.482602 7.92634 0.691714 6.23803 1.42442 4.75393C2.15712 3.26984 3.37032 2.07724 4.86675 1.37007Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiAtSign;
